import { Box, Typography, styled } from "@mui/material";
import ProductObjectImage from "./ProductObjectImage";

function ProductItem({ product, rotation, pageMove, transitionToggle, slideProgress, selectedProduct }) {
  return (
    <ProductItemWrapper>
      <ProductCenterItems>
        <img src={product?.open_image} alt="balm" />

        <ProductObjects pageMove={pageMove} rotation={rotation}>
          {product?.objects?.map((object, index) => (
            <ProductObjectImage
              key={`product-object-${index}`}
              object={object}
              transitionToggle={transitionToggle}
              slideProgress={slideProgress}
            />
          ))}
        </ProductObjects>

        <ProductTitle>
          <Typography fontSize="34px" fontWeight={800}>
            {selectedProduct?.texts?.title}
          </Typography>

        </ProductTitle>
      </ProductCenterItems>
    </ProductItemWrapper>
  );
}


const ProductItemWrapper = styled(Box)(() => ({
  position: "relative",
  width: "100%",
  height: "100%",
}));

const ProductTitle = styled(Box)(({ theme }) => ({
  position: "absolute",
  bottom: -150,
  left: '50%',
  transform: 'translateX(-50%)',
  whiteSpace: 'nowrap',
  color: '#ffffff',
  fontSize: '20px',

  [theme.breakpoints.up('md')]: {
    display: 'none'
  },

  [theme.breakpoints.down('sm')]: {
    bottom: "-130px",
  }
}));

const ProductObjects = styled(Box)(({ pageMove }) => ({
  position: "fixed",
  left: "50%",
  top: "50%",
  transform: `translate(${pageMove?.[0]}px, ${pageMove?.[1]}px)`,
}));

const ProductCenterItems = styled(Box)(({theme}) => ({
  position: "fixed",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",

  ":before": {
    content: "''",
    position: "absolute",
    bottom: "-120px",
    left: "50%",
    transform: "translateX(-50%)",
    width: "80%",
    height: 10,
    borderRadius: "50%",
    background: "radial-gradient(circle, rgba(0,0,0,1) 0%, rgba(0,0,0,0) 100%)",
    filter: "blur(6px)",
    opacity: 0.3,
    [theme.breakpoints.down('sm')]: {
      bottom: "-90px",
    }
    
  },

  "> img": {
    margin: "auto",
    width: "300px",
    height: "300px",
    objectFit: "contain",
    position: "relative",
    zIndex: 3,
    animation: 'image-zooming 6s alternate infinite',

  },

  "@keyframes image-zooming": {
    "0%": {
      transform: "scale(1) rotate(0)",
    },

    "100%": {
      transform: "scale(1.05) rotate(4deg)",
    },
  },
}));

export default ProductItem;
